import Admin from "../Admin";
import React from "react";
import CardAdminContactTypeList from "../../../Component/Card/Admin/ContactType/CardAdminContactTypeList";
import PageHeader from "../../../Component/PageHeader";
import MUIButton from "@mui/material/Button";
import MUIAddIcon from "@mui/icons-material/Add";

export default class ContactTypeList extends Admin {
  /**
   * Render the content.
   */
  renderContent() {
    return <CardAdminContactTypeList />;
  }

  /**
   * Render the header.
   */
  renderHeader() {
    const handleClickCreate = () => {
      this.props.history.push({
        pathname: "/admin/contactType",
      });
    };

    const buttons = [
      <MUIButton
        component="label"
        variant="contained"
        startIcon={<MUIAddIcon />}
        onClick={handleClickCreate}
      >
        Create New
      </MUIButton>,
    ];

    return <PageHeader title="Contact Types" buttons={buttons} />;
  }
}
